// Lightweight logger utility.
//
// In production builds (NODE_ENV === "production") this is a no-op for `debug`,
// `info`, and `warn`. `error` is preserved because actual runtime errors are
// valuable for users reporting bugs via DevTools. All other dev-only chatter
// stays out of production bundles to avoid leaking diagnostic info.
//
// Usage:
//   import { log } from "@/lib/logger";
//   log.debug("[module] something happened", payload);
//   log.warn("[module] non-fatal", err);
//   log.error("[module] failure", err);  // always logs
//
const isDev =
  typeof process !== "undefined" &&
  process.env &&
  process.env.NODE_ENV !== "production";

const noop = () => {};

export const log = {
  debug: isDev ? console.debug.bind(console) : noop,
  info: isDev ? console.info.bind(console) : noop,
  warn: isDev ? console.warn.bind(console) : noop,
  // `error` is preserved in production so legitimate failures remain visible
  // in user devtools / Sentry-style reporters. Use sparingly.
  error: console.error.bind(console),
};

export default log;
